import { SvgIconComponent } from './type';
import { AccountMeterScaleType } from '../../../common/model/account/accountMeterScaleType';
import { DayIcon, NightIcon, MainIcon, HalfPeak } from '../../../assets/icons';

export const AccountMeterScaleTypeToIcon: Record<AccountMeterScaleType, SvgIconComponent> = {
    [AccountMeterScaleType.Day]: DayIcon,
    [AccountMeterScaleType.Night]: NightIcon,
    [AccountMeterScaleType.Main]: MainIcon,
    [AccountMeterScaleType.HalfPeak]: HalfPeak,
    [AccountMeterScaleType.Peak]: DayIcon,
};

export const TariffToIcon: Record<string, SvgIconComponent> = {
    'День': DayIcon,
    'Ночь': NightIcon,
    'Основная': MainIcon,
    'Полупик': HalfPeak,
    'Пик': DayIcon,
};
